export const normalUrl = "https://aikaidan.datang360.com/app-api";
export const batchUrl = "https://aikaidanpifa.datang360.com/app-api";
export const apkUrl =
  "https://aikaidanpeisong.oss-cn-shenzhen.aliyuncs.com/version/apk/爱开单配送版_v1.1.2.apk";
